// import $ from 'jquery';
//
// export default function typewriter() {
//   $('.block-manifest p').addClass('item');
//
//   let wrapper
//   let i
//   const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))
//
//   async function writingAll (stringTarget, container){
//     wrapper = document.querySelector('['+container+']')
//     const stringsContainer = document.getElementsByClassName(stringTarget)
//
//     while(wrapper){
//       for (i=0; i <  stringsContainer.length ; i++){
//         const string = stringsContainer[i].textContent
//         await write(string)
//         await sleep(1000)
//         await erase()
//         await sleep(300)
//         await sleep(300)
//       }
//     }
//   }
//
//   async function write(text){
//     let index = 0
//     while(index < text.length){
//       const timeout = 100
//       await sleep(timeout)
//       index++
//       wrapper.innerHTML = text.substring(0, index)
//     }
//   }
//
//
//   async function erase() {
//     while(wrapper.textContent.length){
//       const timeout = 100
//       await sleep(timeout)
//       wrapper.textContent = wrapper.textContent.substring(0, wrapper.textContent.length - 2)
//     }
//   }
//
//   writingAll('item', 'data-text');
// }


import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'block-manifest';
const slidableBreakpoint = '767px';
let time = 0;
let wrapper;
let i;
// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class SectorsSlider {
  constructor(el) {
    this._sliderActivated = false;

    this.el = el;
    this.swiper = null;

    this.$text = $(el).find('p');


    this.mediaMatcher = window.matchMedia(`(max-width: ${slidableBreakpoint})`);

    if (this.mediaMatcher.matches) {
      this.initTypewriter();
    }

    this.mediaMatcher.addEventListener('change', (event) => {
      if (event.matches) {
        this.initTypewriter();
      }
    });
  }

  initTypewriter() {
    this.$text.addClass('item');
    let firstLine;
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))

    async function writingAll(stringTarget, container) {
      wrapper = document.querySelector(container)
      const stringsContainer = document.getElementsByClassName(stringTarget)

      while (wrapper) {
        for (i = 0; i < stringsContainer.length; i++) {
          time = 0;

          const string = stringsContainer[i].textContent;

          if (i == 0) {
            firstLine = string
          } else {
            if (string == firstLine) {
              return;
            }
          }

          await write(string)
          await erase(1000)
          await sleep(1000)
        }
      }
    }

    async function write(text) {
      let index = 0
      while (index < text.length) {
        const timeout = 100
        await sleep(timeout)
        index++
        wrapper.querySelector('p.active').innerHTML = text.substring(0, index)
        wrapper.querySelector('p.active').classList.add('is-start');
      }
    }

    async function erase() {
      if (wrapper.querySelector('p.active').nextElementSibling != null) {
      wrapper.querySelector('p.active').classList.add('is-finish');
      wrapper.querySelector('p.active').nextElementSibling.classList.add('active');

      const highlightedItems = document.querySelectorAll('#manifest-complete p');

      highlightedItems.forEach(function (item) {
        if (item.classList.contains('active')) {
          if (time == 0) {
            item.classList.remove('active')
            time = 1;
          }
        }
      });
      }
    }

    writingAll('item', '#manifest-complete');

  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new SectorsSlider(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
